import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { NavLink, useLocation } from 'react-router'

import { Role } from 'common-billing-server/types'
import { Path } from '../../routes/path'
import { RoleBasedComponent } from '../common/RoleBasedLink'

const links = [
    { label: 'Licenses', path: Path.licenses, role: Role.licenseAdmin },
    { label: 'Installations', path: Path.installations, role: Role.invoiceOnly },
    { label: 'Billing', path: Path.billing2, role: Role.invoiceOnly },
    { label: 'Billing (legacy)', path: Path.billing, role: Role.invoiceOnly },
]

export const CustomerLinks = ({ customerId }: { customerId: string }) => {
    const location = useLocation()
    const search = new URLSearchParams({ customerId }).toString()

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {links.map(({ label, path, role }) => (
                <RoleBasedComponent key={path} minimumAllowedRole={role}>
                    <Button component={NavLink} to={`${path}?${search}`} state={{ from: location }} variant="outlined">
                        {label}
                    </Button>
                </RoleBasedComponent>
            ))}
        </Box>
    )
}
